import React from 'react';
import PropTypes from 'prop-types';
import {
  FDPaper, FDStack, FDEmphasisSurface,
} from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { InfoBoxError } from './InfoBoxError';
import metaOverrideSet from './MetaOverrideSet';


const getComponent = (detail) => {
  const isEmphasized = detail.attr('isEmphasized');
  return isEmphasized === 'true' ? FDEmphasisSurface : FDPaper;
};


export const InfoBox = (props) => {
  const { resource } = props;
  const PaperComponent = getComponent(resource);

  return (
    <PaperComponent
      padding={2}
      flex={1}
      {...dataAttrs('create-your-plan-info-box')}
    >
      <FDStack direction={'column'} justifyContent={'center'} alignItems={'flex-start'}>
        <MetaControl resource={resource} metaOverrideSet={metaOverrideSet} attrName={'title'} />
        <MetaControl resource={resource} metaOverrideSet={metaOverrideSet} attrName={'details'} />
        <InfoBoxError resource={resource} />
      </FDStack>
    </PaperComponent>
  );
};

InfoBox.defaultProps = {
};

InfoBox.propTypes = {
  resource: PropTypes.object.isRequired,
};
